import { useScrollProgress } from "../../hooks/useScrollProgress";

export default function ScrollProgress() {
  const progress = useScrollProgress();

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: `${progress * 100}%`,
        height: 3,
        background: "linear-gradient(to right, #D4A843, #F0C75E)",
        boxShadow: "0 0 10px rgba(212, 168, 67, 0.5)",
        zIndex: 9999,
        transition: "width 0.05s linear",
        pointerEvents: "none",
      }}
    />
  );
}
